import { isNotNullValues } from '@Utils/isNotNullValues';
import { isCostCenterMatchReceiveType } from './isCostCenterMatchReceiveType';

interface ValidRequiredProps {
  compId: number | null;
  mrFor: number | null;
  ccTypeId: number | null;
  ccId: number | null;
  warrantyTypeId: number | null;
  receiveStoreId: number | null;
}

export const isValidRequiredFields = ({
  compId,
  mrFor,
  ccTypeId,
  ccId,
  warrantyTypeId,
  receiveStoreId,
}: ValidRequiredProps): boolean => {
  if (isNotNullValues(compId, mrFor, ccTypeId, ccId, warrantyTypeId)) {
    const isReceiveStore = isCostCenterMatchReceiveType(
      Number(ccTypeId),
      Number(ccId)
    );

    if (isReceiveStore) {
      if (isNotNullValues(receiveStoreId)) {
        return true;
      }
      return false;
    }

    return true;
  }

  return false;
};
